// extracted by mini-css-extract-plugin
module.exports = {"container":"Publications_container__2sJ0O","nav":"Publications_nav__xMoqZ","button":"Publications_button__2H25l","active":"Publications_active__19goc"};